import * as React from "react";
function SvgCircleBan(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={1.01}>
        <circle cx={10} cy={10} r={9.5} />
        <path d="M3 3l14 14" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleBan);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
